import {Pipe, PipeTransform} from "@angular/core";
import {TrainingSession} from "@models";
import dayjs from "dayjs";

@Pipe({
	name: "filterSessionByDate",
	standalone: false,
})
export class FilterSessionByDatePipe implements PipeTransform {
	transform(trainingSessions: TrainingSession[], ...args: any[]) {
		if (args.length > 0 && args[0].filterDate !== undefined) {
			const filterDate = dayjs(args[0].filterDate);
			const filteredTrainingSessions: TrainingSession[] = trainingSessions?.filter((session) => {
				const sessionStartDate = dayjs(session.startTime);
				const sameDay =
					sessionStartDate.year() === filterDate.year() &&
					sessionStartDate.month() === filterDate.month() &&
					sessionStartDate.day() === filterDate.day();
				return sameDay;
			});

			return filteredTrainingSessions;
		} else {
			return trainingSessions;
		}
	}
}
